import React, { useEffect, useState } from 'react'
import s from './mainPage.module.css'
import NavBar from './NavBar'
import FirstPages from './pages/FirstPages'
import logo from '../img/logo.png'
import {  useAppSelector } from '../app/Hooks'
import FiltrPage from './pages/FiltrPage'
import Dashboard from './pages/Dashboard'
import Address from './pages/Address/Address'
import Reports from './pages/Reports/Reports'
import MainSearch from './pages/seach/MainSearch'
import Error500 from './Error500'
import Preloder2 from './pages/Preloder/Preloder'


type Props = {
  resolve?: boolean
}



const MainPage = ({ resolve }: Props) => {

  const { loading, errors } = useAppSelector(state => state.pages)
  
  const activePage = useAppSelector(state => state.pages.activePage)
  
  const [filterShow, setFilterShow] = useState(false)
 
  const [preloader, setPreloader] = useState(false)



 
  useEffect(() => {
    if (loading) {
      setPreloader(true)
      setTimeout(() => {
        setPreloader(false)
      }, 1000)
    }

  }, [loading])
  
  
  const activeNavPage = (i: number) => {


    switch (i) {
      case 0: return <Dashboard />

      case 1: return <FirstPages showFilter={setFilterShow} isloader={preloader} />

      case 2: return <Address />

      case 3: return <Reports />

      default: <Dashboard />
    }
  }




  return (
    <div className={s.mainPage}>
      {errors ? <Error500 /> : <>
        <div className={s.header}>
          <div className={s.logoBlock}>

            <img className={s.logo} src={logo} alt="logo" />

          </div>

          {activePage === 1 && <MainSearch />}
        </div>

        <div className={s.conteiner}>
          <NavBar resolve={resolve} />


          <div className={!preloader ? s.pages : s.pagesLoading} >

            {preloader && <Preloder2 />}

            {activeNavPage(activePage)}
            {(filterShow && activePage === 1) && <FiltrPage close={() => setFilterShow(false)} />}


          </div>

        </div>

      </>}
    </div>
  )
}

export default MainPage